export default __webpack_public_path__ + "static/media/unique18.535996ba.PNG";